export default __webpack_public_path__ + "static/media/done.2b4308dd.gif";